import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SELECTOR_STATS_EVENTS,
  SELECTOR_STATS_STATS,
  StatsActionTypes,
  SELECTOR_STATS_SHOW_STATS,
} from 'src/store/reducers/stats';
import StatsService from 'src/services/StatsService';

const useStats = () => {
  const stats = useSelector(SELECTOR_STATS_STATS);
  const events = useSelector(SELECTOR_STATS_EVENTS);

  const showStats = useSelector(SELECTOR_STATS_SHOW_STATS);
  const dispatch = useDispatch();

  const updateStats = useCallback(() => {
    const data = {
      media: StatsService.getMediaData(),
      general: StatsService.getGeneralData(),
      buffer: StatsService.getBufferedData(),
      chunks: StatsService.getChunkData(),
    };

    dispatch({
      type: StatsActionTypes.STATS,
      payload: data,
    });
  }, [dispatch]);

  const updateEvents = useCallback(
    (_event: Event, eventType: string) => {
      dispatch({
        type: StatsActionTypes.EVENTS,
        payload: { ...events, [eventType]: events[eventType] + 1 },
      });
    },
    [dispatch, events],
  );

  const setShowStats = useCallback(() => {
    dispatch({
      type: StatsActionTypes.SHOW_STATS,
    });
  }, [dispatch]);

  const setHideStats = useCallback(() => {
    dispatch({
      type: StatsActionTypes.HIDE_STATS,
    });
  }, [dispatch]);

  return {
    stats,
    events,
    showStats,
    updateStats,
    updateEvents,
    setShowStats,
    setHideStats,
  };
};

export default useStats;
